/**
 * message redux reducer
 * 
 * @author    Maurizio Tidei
 * @copyright © 2018 contexagon GmbH
 */


import {
    CLEAR_DIALOG_MESSAGE, CLEAR_MESSAGE, SHOW_DIALOG_MESSAGE, SHOW_MESSAGE
} from "./consts";


const initialState = {
    message: "",
    showMessage: false,
    showDialogMessage: false
}


export default function messageReducer(state = initialState, action) {

    switch(action.type) {

        case SHOW_MESSAGE:
            return {...state, message: action.message, showMessage: true};

        case CLEAR_MESSAGE:
            return {...state, showMessage: false};

        case SHOW_DIALOG_MESSAGE:
            return {...state, dialogMessage: action.message, dialogTitle: action.title, showDialogMessage: true};

        case CLEAR_DIALOG_MESSAGE:
            return {...state, showDialogMessage: false};

        default:
            return state;
    }
}
